import { CategoryQuestions } from '../types';

export const meditationQuestions: CategoryQuestions = {
  title: 'Personalize Your Meditation',
  questions: {
    preferredStyle: {
      label: 'Do you prefer guided or silent meditations?',
      type: 'radio',
      options: ['Guided with instructions', 'Mostly silent with gentle cues', 'Mix of both']
    },
    primaryGoal: {
      label: 'What are you seeking?',
      type: 'radio',
      options: ['Stress relief', 'Spiritual connection', 'Better sleep', 'Focus and clarity']
    },
    specificFocus: {
      label: 'What would you like to meditate on today?',
      type: 'textarea',
      placeholder: 'Optional - leave blank for general session'
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for you?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  },
  // Practitioner perspective questions
  practitionerTitle: 'Personalize Meditation for Your Client',
  practitionerQuestions: {
    preferredStyle: {
      label: 'Does your client prefer guided or silent meditations?',
      type: 'radio',
      options: ['Guided with instructions', 'Mostly silent with gentle cues', 'Mix of both']
    },
    primaryGoal: {
      label: 'What is your client seeking from meditation?',
      type: 'radio',
      options: ['Stress relief', 'Spiritual connection', 'Better sleep', 'Focus and clarity']
    },
    specificFocus: {
      label: 'What would you like your client to meditate on today?',
      type: 'textarea',
      placeholder: 'Optional - leave blank for general session'
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your client?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  },
  practitionerGroupTitle: 'Personalize Group Meditation for Your Clients',
  practitionerGroupQuestions: {
    groupSize: {
      label: 'How many participants will be in the group?',
      type: 'select',
      options: ['2-3 people', '4-6 people', '7-10 people', '11+ people']
    },
    groupComposition: {
      label: 'What is the group composition?',
      type: 'radio',
      options: ['Family members', 'Friends', 'Coworkers/colleagues', 'Mixed group', 'Meditation group/sangha']
    },
    collectiveExperience: {
      label: 'What is the overall meditation experience of the group?',
      type: 'radio',
      options: ['Mostly beginners', 'Mixed experience levels', 'Mostly experienced', 'All experienced practitioners']
    },
    leadershipStyle: {
      label: 'How should the meditation be led?',
      type: 'radio',
      options: ['Clear step-by-step guidance for all', 'Accommodate different experience levels', 'Minimal guidance for self-directed practice', 'Interactive with group participation']
    },
    sharedIntention: {
      label: 'What is the group\'s shared intention for this meditation?',
      type: 'textarea',
      placeholder: 'Describe what the group hopes to achieve together...'
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your clients?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  },
  groupTitle: 'Personalize Your Group Meditation',
  groupQuestions: {
    groupSize: {
      label: 'How many participants will be in your group?',
      type: 'select',
      options: ['2-3 people', '4-6 people', '7-10 people', '11+ people']
    },
    groupComposition: {
      label: 'What is the group composition?',
      type: 'radio',
      options: ['Family members', 'Friends', 'Coworkers/colleagues', 'Mixed group', 'Meditation group/sangha']
    },
    collectiveExperience: {
      label: 'What is the overall meditation experience of your group?',
      type: 'radio',
      options: ['Mostly beginners', 'Mixed experience levels', 'Mostly experienced', 'All experienced practitioners']
    },
    leadershipStyle: {
      label: 'How should the meditation be led?',
      type: 'radio',
      options: ['Clear step-by-step guidance for all', 'Accommodate different experience levels', 'Minimal guidance for self-directed practice', 'Interactive with group participation']
    },
    sharedIntention: {
      label: 'What is the group\'s shared intention for this meditation?',
      type: 'textarea',
      placeholder: 'Describe what the group hopes to achieve together...'
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your group?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  },
  giftTitle: 'Personalize Meditation for Your Loved One',
  giftQuestions: {
    preferredStyle: {
      label: 'Does your loved one prefer guided or silent meditations?',
      type: 'radio',
      options: ['Guided with instructions', 'Mostly silent with gentle cues', 'Mix of both']
    },
    primaryGoal: {
      label: 'What are they seeking from meditation?',
      type: 'radio',
      options: ['Stress relief', 'Spiritual connection', 'Better sleep', 'Focus and clarity']
    },
    specificFocus: {
      label: 'What would you like them to meditate on?',
      type: 'textarea',
      placeholder: 'Optional - leave blank for general session'
    },
    additionalNotes: {
      label: 'Anything else the AI should know to create a perfect session for them?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  }
};
